import axios from "axios";

const API_URL = "https://selftest-api.mail25.info/v1";
const HEADERS = {
  "Auth-Token": "VgceKVOR805waUlIWrU7vQbavV3SRHz",
  "Content-Type": "application/json",
};

const getDomainStatus = async (domain) => {
  try {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${API_URL}/status?domain=${domain.toLowerCase()}`,
      headers: HEADERS,
    };
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 404) {
        throw new Error("Domain is not present or Domain is inactive.");
      } else {
        throw new Error(`Response status not in 200 ${error.response.data}`);
      }
    }
    throw new Error(`Response status not in 200 ${error}`);
  }
};

const putIncomingMail = async (domain) => {
  let config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `${API_URL}/incoming?domain=${domain.toLowerCase()}`,
    headers: HEADERS,
  };
  const response = await axios.request(config);
  if (response.status !== 200) {
    throw Error(response.error || "Failure in checking incoming mail flow");
  }
  return response.data;
};

const putOutgoingMail = async (domain) => {
  try {
    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${API_URL}/outgoing?domain=${domain.toLowerCase()}`,
      headers: HEADERS,
    };
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    throw new Error(`Response status not in 200 ${error}`);
  }
};

const getMailflowStatus = async (token) => {
  try {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${API_URL}/mailflow/${token}`,
      headers: HEADERS,
    };
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    throw new Error(`Response status not in 200 ${error}`);
  }
};

export { getDomainStatus, putIncomingMail, putOutgoingMail, getMailflowStatus };
